package ru.playa.sce.dto

data class Area(val southWest: Point, val northEast: Point) {
    fun contains(point: Point) =
            southWest.latitude <= point.latitude && point.latitude <= northEast.latitude
                    && southWest.longitude <= point.longitude && point.longitude <= northEast.longitude
}
